import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme/tokens.css';
import './index.css';
import App from './App.tsx';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { FluentProvider } from '@fluentui/react-components';
import { undpTheme } from './theme/undpTheme.ts';
import { ToastProvider } from './components/Toast.tsx';
import { initializeIcons } from '@fluentui/react/lib/Icons';

// Initialize Fluent UI icons
initializeIcons();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <FluentProvider theme={undpTheme}>
          <ToastProvider>
            <App />
          </ToastProvider>
        </FluentProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
